export default "__VITE_ASSET__BHALWJeG__"